import Button from '../components/common/Button';
import ContactCTA from '../components/common/ContactCTA';
import { industryDetails, industryProblems } from '../data/industryDetails';

function Industries() {
  return (
    <>
      <section className="industries-page-hero" aria-labelledby="industries-page-title">
        <div className="container industries-page-hero__inner">
          <p className="eyebrow">Industries</p>
          <h1 id="industries-page-title">Industrial repair support across Canada</h1>
          <p>
            We support gearbox, hydraulic, and related mechanical repair needs for industrial customers working in
            demanding equipment environments.
          </p>
          <div className="industries-page-hero__actions">
            <Button to="/contact">Request a Quote</Button>
            <Button href="tel:+14374357083" variant="secondary">
              Call (437) 435-7083
            </Button>
          </div>
        </div>
      </section>

      <section className="industries-page-section">
        <div className="container">
          <div className="industries-page-grid">
            {industryDetails.map((industry) => (
              <article key={industry.id} className="industries-page-card">
                <div
                  className="industries-page-card__image"
                  style={{ '--industry-image': `url(${process.env.PUBLIC_URL}${industry.image})` }}
                  aria-label={`${industry.title} industry repair image`}
                />
                <div className="industries-page-card__body">
                  <img src={`${process.env.PUBLIC_URL}${industry.icon}`} alt="" aria-hidden="true" />
                  <h2>{industry.title}</h2>
                  <p>{industry.summary}</p>
                  <ul>
                    {industry.needs.map((need) => (
                      <li key={need}>{need}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="industries-page-problems">
        <div className="container industries-page-problems__inner">
          <div>
            <p className="eyebrow">Repair Needs</p>
            <h2>Problems that slow industrial equipment down</h2>
            <p>
              Gearbox and hydraulic failures often start with small signs: leaks, heat, vibration, pressure loss, or
              unusual noise. A repair review helps identify the issue before replacement becomes the only path.
            </p>
          </div>
          <div className="industries-page-problem-list">
            {industryProblems.map((problem) => (
              <article key={problem}>
                <span aria-hidden="true" />
                <p>{problem}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="industries-page-service-note">
        <div className="container industries-page-service-note__inner">
          <p className="eyebrow">Canada-Wide Service</p>
          <h2>Send the details from wherever your equipment is working</h2>
          <p>
            Share photos, nameplates, dimensions, symptoms, and location details so we can understand the repair need
            and follow up with a practical next step.
          </p>
          <Button to="/contact" variant="outline-light">
            Start a Repair Request
          </Button>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}

export default Industries;
